<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-6" style="margin-bottom: 80px;">
                    <img
                      class="aligncenter size-full hc-managed-firewall-img"
                      src="/static/assets/images/forget_pass.png"
                      style="max-width: 100%;"
                    />
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <h2 class="wow fadeIn">Forgot Password</h2>
                    <p style="margin-bottom: 20px;">Please enter your sign in email address below and we will send you an email with instructions.</p>
                    <div role="form" class="wpcf7" dir="ltr" lang="en-US">
                      <div class="screen-reader-response"></div>
                      <form
                        action="#"
                        method="post"
                        class="wpcf7-form"
                        @submit.prevent="submit"
                        novalidate
                      >
                        <div class="hostcluster-contact row">
                          <div class="col-md-12">
                            <label>
                              E-mail
                              <span class="wpcf7-form-control-wrap email">
                                <input
                                  name="email"
                                  size="40"
                                  class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                  aria-required="true"
                                  aria-invalid="false"
                                  placeholder="Enter your email"
                                  type="email"
                                  v-model="email"
                                />
                              </span>
                              <small
                                id="emailHelp"
                                class="form-text text-muted"
                                v-if="emailRequiredError"
                                style="
                                  color: red;
                                  font-size: 1em;
                                  font-weight: bold;
                                  margin: 12px 0;
                                  display: block;
                                "
                                >Your Email is Required</small
                              >
                              <small
                                id="emailHelp"
                                class="form-text text-muted"
                                v-if="emailError"
                                style="
                                  color: red;
                                  font-size: 1em;
                                  font-weight: bold;
                                  margin: 12px 0;
                                  display: block;
                                "
                                >Invalid Email address format</small
                              >
                            </label>
                          </div>
                          <div class="col-md-12 text-center">
                            <p
                              class="form-error"
                              v-if="formSuccess"
                              style="color: green; font-size: 1em; font-weight: bold;background: #aee0ae;padding: 10px;border-radius: 5px;"
                            >
                              Email sent successfully.
                            </p>
                            <p
                              class="form-error"
                              v-if="formError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                background: #ffb6b6;
                                padding: 10px;
                                border-radius: 5px;
                              "
                            >
                              Please fill form.
                            </p>
                            <p
                              class="form-error"
                              v-if="submitError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                background: #ffb6b6;
                                padding: 10px;
                                border-radius: 5px;
                              "
                            >
                              {{submitErrorMessage}}
                            </p>
                          </div>
                          <div class="col-md-12">
                            <input
                              value="RECOVER MY PASSWORD"
                              class="wpcf7-form-control wpcf7-submit"
                              type="submit"
                            />
                            <span class="ajax-loader"></span>
                          </div>
                        </div>
                        <div
                          class="wpcf7-response-output wpcf7-display-none"
                        ></div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "personal_signin",
  data() {
    return {
      msg: "Clear Me Out - Sign In",
      email: "",
      emailRequiredError: false,
      emailError: false,
      formSuccess: false,
      formError: false,
      submitError: false,
      submitErrorMessage: "",
    };
  },
  methods: {
    submit: function (e) {
      this.emailError = false;
      this.emailRequiredError = false;
      this.submitErrorMessage = false;
      this.formSuccess = false;
      this.formError = false;

      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (this.email === "") {
        this.emailRequiredError = true;
        return;
      }

      if (!re.test(String(this.email).toLowerCase())) {
        this.emailError = true;
        return;
      }

      const $this = this;
      this.emailRequiredError = false;
      this.ticketNumberRequiredError = false;
      this.emailError = false;

      jQuery
        .post("https://staging.clearmeout.com/support-login.php", {
          email: this.email,
          password: this.password,
        })
        .done(function (data) {
          $this.email = "";
          $this.ticketNumber = "";
          if (data.status == 500) {
            $this.submitError = true;
            $this.submitErrorMessage = data.status_message;
          }
        })
        .fail(function (xhr, status, error) {
          $this.submitError = true;
          $this.submitErrorMessage =  "User does not exists. Please try again.";
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/personal_sign_in_forgot.vue